import React, { FC, useEffect, useState } from "react"
import { container, Container, FlexBox } from "@components/wrapper"
import { CaseStudy } from "@interfaces/case-study"
import Image from "next/image"
import { SliderArrow } from "@components/slider"
import Carousel from "react-multi-carousel"
import { useScreenSize } from "@hooks/useScreenSize"
import clsx from "clsx"
import { AiOutlineArrowRight } from "react-icons/ai"
import CaseStudiesServices from "@lib/api/services/case-study.services"
import { Heading } from "@components/typography"
import Link from "next/link"

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
    slidesToSlide: 3,
    partialVisibilityGutter: 30,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3,
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: { max: 768, min: 464 },
    items: 3,
    slidesToSlide: 3,
  },
}
export const ProjectSection: FC = () => {
  const { screenWidth } = useScreenSize()
  const [isLoading, setIsLoading] = useState(false)
  const [caseStudiesList, setCaseStudiesList] = useState<CaseStudy[]>([])
  const caseStudiesServices = new CaseStudiesServices()

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await caseStudiesServices.getCaseStudiesList()
        if (res.isSuccess) {
          const result = res.getValue()
          setCaseStudiesList(result)
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      } catch (e) {
        setIsLoading(false)
      }
    }

    getData()
  }, [])

  if (!caseStudiesList.length) {
    return <div />
  }

  return (
    <section className={clsx("relative sm:pt-15 pt-10", screenWidth > 576 && container)}>
      <div id="#caseStudy" className="absolute -top-15" />
      <Container className="sm:mb-8 mb-6">
        <div className="mx-auto text-center md:w-[720px]">
          <Heading headingLevel="h3" className="mb-1">
            Proyek
          </Heading>
          <Heading headingLevel="title" className="mb-2">
            Hasil <span className="text-green">Corporate Training</span> Terbaik Kami
          </Heading>
          <Heading headingLevel="subtitle">
            Lihat hasil dan dokumentasi Corporate Training dengan berbagai partner kami
          </Heading>
        </div>
      </Container>

      {screenWidth > 576 ? (
        <Carousel
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          className="pb-2"
          arrows={false}
          renderButtonGroupOutside
          containerClass="-mx-[1.15vw]"
          itemClass="py-0 hover:text-inherit px-[0.9vw]"
          customButtonGroup={
            <SliderArrow
              length={caseStudiesList.length}
              displayedSlide={3}
              leftClassName="top-[55%] w-[42px] h-[42px] -left-[8px]"
              rightClassName="top-[55%] w-[42px] h-[42px] -right-[8px]"
            />
          }
        >
          {caseStudiesList.map((value, index) => (
            <CaseStudyCard data={value} key={index} />
          ))}
        </Carousel>
      ) : (
        <div className="slider-mobile pl-4 w-full !mb-0">
          <FlexBox className="w-max gap-3">
            {caseStudiesList.map((value, index) => (
              <CaseStudyCard data={value} key={index} />
            ))}
          </FlexBox>
        </div>
      )}
    </section>
  )
}

interface CaseStudyCardProps {
  data: CaseStudy
}

const CaseStudyCard: FC<CaseStudyCardProps> = ({ data }) => {
  return (
    <FlexBox direction="col" className="bg-white border border-white-f0 rounded sm-only:w-[75vw]">
      <div className=" w-full relative sm:h-[17.5vw] h-[47.8vw]">
        <Image
          loading="lazy"
          src={data.caseStudyBannerUrl}
          alt="banner-1"
          className="contain fade_in_left border-2 border-white object-cover"
          layout="fill"
        />
      </div>
      <div className="sm:p-6 p-4">
        <h3 className={clsx("text-black font-semibold sm:text-xl", "text-sm")}>
          {data.caseStudyTitle}
        </h3>
        <p
          className={clsx(
            "text-black-67 line-clamp-3 sm:my-4 min-h-[4.7em]",
            "sm-only:text-xxs my-3"
          )}
        >
          {data.companyDescription}
        </p>
        <Link
          href={`/case-study/${data.id}`}
          className="flex gap-1 text-blue font-semibold sm:text-sm text-xs"
        >
          Lihat Selengkapnya <AiOutlineArrowRight className="my-auto" />
        </Link>
      </div>
    </FlexBox>
  )
}
